(function() {
  if (window.jeEditorialReady) return;
  window.jeEditorialReady = true;
  function initialize(root) {
    root.querySelectorAll('[data-je-editorial]').forEach(function(page) {
      if (page.dataset.jeEditorialReady === 'true') return;
      const body = page.querySelector('[data-je-editorial-body]');
      const tools = page.querySelector('[data-je-editorial-tools]');
      const nav = page.querySelector('[data-je-editorial-nav]');
      if (!body || !tools || !nav) return;
      const headings = Array.from(body.querySelectorAll('h2'));
      headings.forEach(function(heading, index) {
        if (!heading.id) heading.id = 'je-topic-' + page.dataset.jeEditorial + '-' + index;
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        nav.appendChild(link);
      });
      const questions = Array.from(body.querySelectorAll('details')).filter(function(detail) { return !detail.classList.contains('je-mobile-nav') && !detail.querySelector('nav') && !detail.querySelector('details'); });
      const search = page.querySelector('[data-je-editorial-search]');
      const input = page.querySelector('[data-je-question-search]');
      const clear = page.querySelector('[data-je-question-clear]');
      const status = page.querySelector('[data-je-question-count]');
      let clearQuestions = function() {};
      if (questions.length > 8 && search && input && clear && status) {
        const values = questions.map(function(detail) { return {detail: detail, text: detail.textContent.toLocaleLowerCase()}; });
        function filter() {
          const tokens = input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
          let found = 0;
          values.forEach(function(item) { const match = tokens.every(function(token) { return item.text.includes(token); }); item.detail.hidden = !match; if (match) found++; });
          status.textContent = status.dataset.template.replace('[count]', String(found)).replace('[total]', String(questions.length));
        }
        clearQuestions = function() { input.value = ''; filter(); };
        input.addEventListener('input', filter);
        input.addEventListener('search', filter);
        clear.addEventListener('click', function() { clearQuestions(); input.focus(); });
        search.hidden = false;
        filter();
      }
      page.addEventListener('click', function(event) {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        let target;
        try { target = document.getElementById(decodeURIComponent(link.hash.slice(1))); } catch (error) { return; }
        if (!target || !page.contains(target)) return;
        clearQuestions();
        let detail = target.closest('details');
        while (detail && page.contains(detail)) { detail.open = true; detail = detail.parentElement.closest('details'); }
        setTimeout(function() { target.setAttribute('tabindex', '-1'); target.focus({preventScroll: true}); }, 0);
      });
      tools.hidden = headings.length < 2 && !(search && !search.hidden);
      nav.hidden = headings.length < 2;
      if (headings.length >= 2) page.dataset.jeEditorialNavigation = 'true';
      page.dataset.jeEditorialReady = 'true';
    });
  }
  document.addEventListener('shopify:section:load', function(event) { initialize(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { initialize(document); }); else initialize(document);
})();
